import * as React from 'react';
import { SCAState, useAdyenSCA } from './adyen_sca_hook';
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';

interface Props {
  action: PaymentAction;
  onAdditionalDetails(state: SCAState): void;
}

export default function SCAIdentifyShopper(props: Props) {
  const { action, onAdditionalDetails } = props;
  useAdyenSCA({ selector: '[data-3ds-identify-shopper]', action, onAdditionalDetails });

  return <div data-3ds-identify-shopper />;
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/sca_identify_shopper.tsx